import { render, staticRenderFns } from "./SkillList.vue?vue&type=template&id=16d1a9d7"
import script from "../../controllers/skill/skill-list.js?vue&type=script&lang=js&external"
export * from "../../controllers/skill/skill-list.js?vue&type=script&lang=js&external"
import style0 from "./SkillList.vue?vue&type=style&index=0&id=16d1a9d7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports